import React, {Component} from "react";
import classNames from "classnames";

class DetailsColumn extends Component {
    render = () => {
        return this.renderContent();
    };

    renderContent = () => {
        const componentClass = this.getComponentClassName();

        return (
            <div className={classNames("details-column", componentClass)}>
                {this.renderHeader()}
                {this.renderBody()}
            </div>
        );
    };

    renderHeader = () => {
        const {headerTitle} = this.props;

        return (
            <div className="header"> {headerTitle} </div>
        )
    };

    renderBody = () => {
    };


    static defaultProps = {
        headerTitle: ""
    };

    getComponentClassName = () => '';
}


export default DetailsColumn;
